import { Box } from "@mui/material";
import { useMemo, useState } from "react";
import { SystemTabs } from "../../components/UIToolkit/Clickable/TabsAndChips/SystemTabs/SystemTabs";
import type { SystemTab } from "../../components/UIToolkit/Clickable/TabsAndChips/SystemTabs/utils";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { AutoPromptSection } from "./sections/AutoPromptSection";
import { CalculateRecurringSection } from "./sections/CalculateRecurring/CalculateRecurringSection";
import { DataLoadSection } from "./sections/DataLoad/DataLoadSection";
import { DbActionsSection } from "./sections/DbActionsSection";
import { SftpProvisioningSection } from "./sections/SftpProvisioningSection";

type TabKey = "auto-prompt" | "data-load" | "recurring" | "db" | "sftp";

export default function OnboardingToolsPage() {
	const [tab, setTab] = useState<TabKey>("auto-prompt");
	const { chosenDepartment } = useHospitalData();

	const tabs: SystemTab<TabKey>[] = useMemo(
		() => [
			{ label: "Auto Prompt", value: "auto-prompt" },
			{ label: "Data Load", value: "data-load" },
			{ label: "Calculate Recurring", value: "recurring" },
			{ label: "DB Actions", value: "db" },
			{ label: "SFTP", value: "sftp" },
		],
		[],
	);

	return (
		<Box
			data-testid="onboarding-tools-page"
			sx={{
				maxWidth: 1400,
				mx: "auto",
				p: 3,
				pb: 4,
				width: "100%",
				minHeight: "100vh",
				height: "100vh",
				overflow: "auto",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<SystemTabs tabs={tabs} currentTab={tab} onTabChange={setTab} sx={{ mb: 2, flexShrink: 0 }} />

			<Box sx={{ flex: 1, overflow: "auto", pb: 6 }}>
				{tab === "auto-prompt" && <AutoPromptSection />}
				{tab === "data-load" && <DataLoadSection />}
				{/* Keyed by department: a proposal, its edits and its save selection all belong to the
				    department they were calculated for, and must not survive a switch to another one. */}
				{tab === "recurring" && <CalculateRecurringSection key={chosenDepartment?.department_id} />}
				{tab === "db" && <DbActionsSection />}
				{tab === "sftp" && <SftpProvisioningSection />}
			</Box>
		</Box>
	);
}
